import { Component, OnInit, OnDestroy, Directive, Input, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, NgControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatSnackBar, MatTableDataSource, MatPaginator } from '@angular/material';
import { UserService } from '../../../shared/services/user.service';
import { EguardConfigService } from '../../../../core/services/config.service';
import { EguardValidationService } from '../../../../core/components/validation/validation.service';
import { OrganizationServices } from '../../../shared/services/organization.services';
import { LocalUserService } from '../../../shared/services/localUser';
import { EguardConfirmatialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';
import { EguardClerkUserFormComponent } from '../userfrom/clerk-userform.component';
import { EguardCustomLoaderService } from '../../../../core/components/custom-loader/custom-loader.service';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { ConfirmationDialogComponent } from '../../../shared/dialog/confirmation-dialog/confirmation-dialog.component';
import { UserDetailsDialogComponent } from 'app/main/shared/dialog/user-details-dialog/user-details-dialog.component';
import { HeaderTitleService } from 'app/services/header-title.service';

@Component({
    selector: 'eguard-clerk-users-component',
    templateUrl: './clerk-users.component.html',
    styleUrls: ['./clerk-users.component.scss'],
    providers: [
        LocalUserService
    ],
    encapsulation: ViewEncapsulation.None
})
export class EguardClerkUsersComponent implements OnInit, OnDestroy {

    rows = new MatTableDataSource<any>();

    @ViewChild(MatPaginator) paginator: MatPaginator;
    reorderable = true;
    org: string;
    private sub: any;
    dialogRef: any;
    token: string;
    inputValue: any = '';

    loadingIndicator: boolean = false;
    @ViewChild('myTable') table: any;
    temp = [];
    displayColumns: string[] = ['name', 'email', 'role', 'status', 'action']

    constructor(
        private eguardConfig: EguardConfigService,
        private router: Router,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
        private organizationServices: OrganizationServices,
        public dialog: MatDialog,
        private userService: UserService,
        private cognitoService: CognitoUtil,
        private eguardCustomLoaderService: EguardCustomLoaderService,
        private localUser: LocalUserService,
        private headerService: HeaderTitleService

    ) {
        this.org = this.localUser.getOrganizationId();
        this.token = this.localUser.getToken();
    }

    ngOnInit() {
        this.rows.paginator = this.paginator;
        this.getAllUsers(this.org);
        setTimeout(() => { this.sendHeaders(); });
    }
    sendHeaders(): void {
        this.headerService.sendHeader('person', 'Users')
    }
    ngOnDestroy() {
        //     this.sub.unsubscribe();
    }

    onDetailToggle(event) {

    }

    toggleExpandRow(row) {
        this.table.rowDetail.toggleExpandRow(row);
    }

    getAllUsers(orgID: string) {
        this.loadingIndicator = true;
        this.organizationServices.getUsersInOrganization(orgID)
            .subscribe(data => {
                this.temp = [...data];
                this.rows.data = data;
                this.loadingIndicator = false;
            }, (error) => {
                this.loadingIndicator = false;
                this.router.navigate(['**']);
            });
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.rows.filter = filterValue;
    }

    deleteOrganization(orgID: string) {
        this.sub = this.organizationServices.deleteOrganization(orgID)
            .subscribe(
                data => {
                    this.eguardCustomLoaderService.hide();
                },
                Error => {

                    this.eguardCustomLoaderService.hide();
                }
            );
    }


    deleteUser(row: any) {
        this.dialogRef = this.dialog.open(ConfirmationDialogComponent);
        this.dialogRef.componentInstance.msg = `Are you sure to want to remove this user`;
        this.dialogRef.afterClosed().subscribe(response => {
            if (response === true) {
                this.userService.deleteUser(row.id).subscribe(data => {
                    this.eguardCustomLoaderService.hide();
                    this.getAllUsers(this.org)
                }, Error => {
                    this.eguardCustomLoaderService.hide();
                });
            }
        });
    }




    addUser() {
        this.openUserForm(this.org);
    }

    openUserForm(organizationId: string) {

        this.dialogRef = this.dialog.open(EguardClerkUserFormComponent, {
            data: organizationId,
            height: '650px !important',
            panelClass: 'adminCreateUser',
        });
        this.dialogRef.afterClosed()
            .subscribe(response => {
                if (response) {
                    this.eguardCustomLoaderService.hide();
                    this.getAllUsers(this.org);
                }
            });
    }

    userDetails(user) {
        this.loadingIndicator = true
        this.userService.getUserById(this.org, user.id).subscribe(userDetails => {
            this.organizationServices.getOrganizationList().subscribe(org => {
                this.loadingIndicator = false
                this.dialogRef = this.dialog.open(UserDetailsDialogComponent, {
                    data: {
                        userDetails: user,
                        caseDetails: userDetails,
                        orgList: org
                    },
                    panelClass: 'userDialog',
                    width: '70%',
                });
                this.dialogRef.afterClosed()
                    .subscribe(response => {
                        if (response) {
                            this.getAllUsers(this.org);
                        }
                    });
            })

        })

    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/users/clerk-users.component.ts